import { Button } from "@/components/ui/button"
import { gql } from "@/generated"
import {
  FinchConnectSessionIdQuery,
  FinchConnectSessionIdQueryVariables,
} from "@/generated/graphql"
import { useMutation, useQuery } from "@apollo/client"
import { ErrorEvent, useFinchConnect } from "@tryfinch/react-connect"
import { useState } from "react"
import * as React from "react"

const GET_FINCH_SESSION_ID = gql(`
  query FinchConnectSessionId {
    finchConnectSessionId
  }
`)

const CONNECT_ORGANIZATION_TO_FINCH = gql(`
  mutation ConnectOrganizationToFinch($input: ConnectOrganizationToFinchInput!) {
    connectOrganizationToFinch(input: $input) {
      organization {
        id
        name
        finchAccountStatus
      }
      errors {
        fullMessages
      }
    }
  }
`)

export const FinchConnectWidget = ({
  setError,
}: {
  setError: (error: boolean) => void
}) => {
  const { loading, data } = useQuery<
    FinchConnectSessionIdQuery,
    FinchConnectSessionIdQueryVariables
  >(GET_FINCH_SESSION_ID)
  const [execConnectOrgToFinch] = useMutation(CONNECT_ORGANIZATION_TO_FINCH)
  const [processing, setProcessing] = useState(false)

  const onSuccess = async ({ code }: { code: string }) => {
    try {
      const { data } = await execConnectOrgToFinch({
        variables: { input: { authorizationCode: code } },
      })
      setError(
        !!data?.connectOrganizationToFinch.errors &&
          data.connectOrganizationToFinch.errors.length > 0,
      )
    } catch (e) {
      console.error(e)
      setError(true)
    }

    setProcessing(false)
  }

  /**
   * @param {string} errorMessage - The error message
   * @param {'validation_error' | 'employer_error'} errorType - The type of error
   * - 'validation_error': Finch Connect failed to open due to validation error
   * - 'employer_connection_error': The errors employers see within the Finch Connect flow
   */
  const onError = ({ errorMessage, errorType }: ErrorEvent) => {
    console.error(errorMessage, errorType)
    setError(true)
    setProcessing(false)
  }

  const onClose = () => {
    console.log("User exited Finch Connect")
    setProcessing(false)
  }

  const { open } = useFinchConnect({
    sessionId: data?.finchConnectSessionId,
    onSuccess,
    onError,
    onClose,
  })

  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : processing ? (
        <p>Processing...</p>
      ) : (
        <Button
          onClick={() => {
            setError(false)
            setProcessing(true)
            open()
          }}
        >
          Sync My Payroll
        </Button>
      )}
    </div>
  )
}
